import { jsx as _jsx } from "react/jsx-runtime";
import { RootHydrateFallback, SvgIcon } from '@/core/ui';
import { initiateAuthUser, validateToken } from '@/shared/modules/auth/business/thunk';
import { NavLink, Navigate, createBrowserRouter } from 'react-router-dom';
import { customerDebtReportRoute, customersRoute, edoRoute, ordersRoute, priceListsRoute, reclamationsRoute, settingsRoute, shippingRoute, stockReceiptRoutes, stocksRoute, supplierDebtReportRoute, suppliersRoute, } from './routes';
import { AuthorizedLayout } from '@/admin/components/AuthorizedLayout';
import { store } from '@/admin/store';
import { t } from '@/core/localization';
import houseIcon from '@/core/svg/fa/house.svg';
import { documentFlowEnabled } from './documentFlowEnabled';
// Multiple Routes in a single file.
// If you want to avoid loading multiple chunks for **nested** routes, you could store them all in the same file and
// return them to the individual routes. Modern bundlers will latch onto the same Promise for the different
// import() invocations.
// Example below: <CrossdockingReceipt /> and <CrossdockingReceiptItems /> both have the same import path and therefore
// have a single chunk.
// For any RouteObject that is gonna use breadcrumb data, RouteObjectWithCrumbs type should be used for proper type safety.
export async function rootLoader() {
    try {
        // TODO: to delete the comment later
        // await store.dispatch(validateToken()).unwrap();
        const tokenValidationResult = await store.dispatch(validateToken());
        if (tokenValidationResult.meta.requestStatus !== 'fulfilled') {
            return;
        }
        await store.dispatch(initiateAuthUser()).unwrap();
    }
    catch (error) {
        return error;
    }
}
export const router = createBrowserRouter([
    {
        path: 'login',
        lazy: async () => {
            const { Login } = await import('@/shared/modules/auth/Login');
            return { Component: Login };
        },
    },
    {
        path: '/',
        // TODO: to delete later
        // lazy: async () => {
        // 	const { AuthorizedLayout } = await import('@/admin/components/AuthorizedLayout');
        // 	return { Component: AuthorizedLayout };
        // },
        Component: AuthorizedLayout,
        loader: rootLoader,
        HydrateFallback: () => _jsx(RootHydrateFallback, { caption: t('access.levels.loading.spinner.caption') }),
        handle: {
            crumb: () => (_jsx(NavLink, { to: "/", title: "home", children: _jsx(SvgIcon, { icon: houseIcon, size: "sm" }) })),
        },
        children: [
            // Homepage
            { path: '/', element: _jsx(Navigate, { to: "orders", replace: true }) },
            // General section
            ordersRoute,
            customersRoute,
            suppliersRoute,
            priceListsRoute,
            ...stockReceiptRoutes,
            stocksRoute,
            shippingRoute,
            // Document flow section
            ...(documentFlowEnabled ? [reclamationsRoute, edoRoute] : []),
            // Reports section
            customerDebtReportRoute,
            supplierDebtReportRoute,
            // Settings section
            settingsRoute,
            // Other routes
            {
                path: 'access',
                lazy: async () => {
                    const { NoAccess } = await import('@/shared/components');
                    return { Component: NoAccess };
                },
            },
            {
                path: '*',
                lazy: async () => {
                    const { NotFound } = await import('@/shared/components');
                    return { Component: NotFound };
                },
            },
        ],
    },
]);
